/* unplugin-vue-components disabled */import { render } from "./LicenseFooter.vue?vue&type=template&id=7f776501"
const script = {}

import "./LicenseFooter.vue?vue&type=style&index=0&id=7f776501&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__